import { Livewire } from '@shared/livewire.js'
import '@shared/forms/stripe.js'
import '@shared/el/clipboard.js'

Livewire.start()
